const normalize = (value = '') => String(value || '').replace(/\s+/g, ' ').trim();
const normalizeType = (item = {}) => normalize(
  item.knowledgeType || item.factType || item.category
).toLowerCase();
const getText = (item = {}) => normalize([
  item.title,
  item.content || item.summary,
  item.sourceText,
].filter(Boolean).join(' '));

export const CAPTURE_DESTINATIONS = Object.freeze({
  MEDICATIONS: 'Medications',
  ALLERGIES: 'Allergies',
  HEALTH_PROFILE: 'Health Profile',
  CONTACTS: 'Contacts',
  GOALS: 'Goals',
  PROFILE: 'Profile',
  CARE_KNOWLEDGE: 'Care Knowledge',
});

export const getCaptureSuggestionDestination = (item = {}) => {
  const type = normalizeType(item);
  const text = getText(item);

  if (type === 'medication') return CAPTURE_DESTINATIONS.MEDICATIONS;
  if (type === 'allergy' || /\ballerg(?:y|ies|ic)\b/i.test(text)) {
    return CAPTURE_DESTINATIONS.ALLERGIES;
  }
  if (
    type === 'diagnosis'
    || (type === 'condition' && /\bdiagnos(?:is|ed|es)\b/i.test(text))
  ) {
    return CAPTURE_DESTINATIONS.HEALTH_PROFILE;
  }
  if (type === 'contact') return CAPTURE_DESTINATIONS.CONTACTS;
  if (type === 'goal') return CAPTURE_DESTINATIONS.GOALS;
  if (
    type === 'identity'
    || (
      type === 'profile'
      && /\b(?:date of birth|dob|legal name|preferred name|pronouns?|primary language|lives? with|caregiver is|guardian is)\b/i.test(text)
    )
  ) {
    return CAPTURE_DESTINATIONS.PROFILE;
  }
  return CAPTURE_DESTINATIONS.CARE_KNOWLEDGE;
};

export const isStructuredCaptureSuggestion = (item = {}) => (
  getCaptureSuggestionDestination(item) !== CAPTURE_DESTINATIONS.CARE_KNOWLEDGE
);

export const getCaptureDestinationMessage = (destination = '', count = 1) => {
  const plural = Number(count) !== 1;
  const found = {
    [CAPTURE_DESTINATIONS.MEDICATIONS]: `Medication${plural ? 's' : ''} found`,
    [CAPTURE_DESTINATIONS.ALLERGIES]: `Allerg${plural ? 'ies' : 'y'} found`,
    [CAPTURE_DESTINATIONS.HEALTH_PROFILE]: `Diagnos${plural ? 'es' : 'is'} found`,
    [CAPTURE_DESTINATIONS.CONTACTS]: `Contact${plural ? 's' : ''} found`,
    [CAPTURE_DESTINATIONS.GOALS]: `Goal${plural ? 's' : ''} found`,
    [CAPTURE_DESTINATIONS.PROFILE]: `Profile detail${plural ? 's' : ''} found`,
    [CAPTURE_DESTINATIONS.CARE_KNOWLEDGE]: `Observation${plural ? 's' : ''} found`,
  }[destination] || `Detail${plural ? 's' : ''} found`;
  const action = {
    [CAPTURE_DESTINATIONS.MEDICATIONS]: 'Review before adding to Medication List.',
    [CAPTURE_DESTINATIONS.ALLERGIES]: 'Review before adding to Allergy List.',
    [CAPTURE_DESTINATIONS.HEALTH_PROFILE]: 'Review before adding to Health Profile.',
    [CAPTURE_DESTINATIONS.CONTACTS]: 'Review before adding to Contacts.',
    [CAPTURE_DESTINATIONS.GOALS]: 'Review before adding to Goals.',
    [CAPTURE_DESTINATIONS.PROFILE]: 'Review before adding to Profile.',
    [CAPTURE_DESTINATIONS.CARE_KNOWLEDGE]: 'Added to Care Knowledge.',
  }[destination] || 'Review before adding.';

  return `${count > 1 ? `${count} ` : ''}${found} → ${action}`;
};
